import React from 'react'
import { PlusIcon } from '@myxplor/icons'
import { FormButton, FormDisplayErrors } from '@myxplor/forms'
import { totalTimeForDay, timeFormatted } from '../helpers'
import Session from './session'

const HoursAvailable = ({ hoursAvailable, hoursClaimed, overTime }) => {
  if (hoursClaimed === 0) {
    return timeFormatted(hoursAvailable) + ' available'
  }

  const hoursClaimedFormatted = `You are claiming ${timeFormatted(hoursClaimed)}. `
  const hoursTotalFormatted = `${timeFormatted(hoursAvailable)} are available for this day`

  if (overTime) {
    return <FormDisplayErrors errors={[hoursClaimedFormatted, 'Only ' + hoursTotalFormatted]} />
  }

  return hoursClaimedFormatted + hoursTotalFormatted
}

const EnrolmentsInDay = ({ enrolments = [] }) => (
  <div className="issCaseClaim--enrolmentsInDay">
    Eligible enrolments
    <ul>
      {enrolments.map(({ EnrolmentId }, i) => (
        <li key={'enrolment' + i}>{EnrolmentId}</li>
      ))}
    </ul>
  </div>
)

export const SelectSessions = ({
  educators = [],
  enrolments = [],
  addKey,
  removeKey,
  onChange,
  values = [],
  nameBase,
  hoursAvailable,
  changeEditingSession,
  curentlyEditingSession,
  resetEditingSession,
}) => {
  const hoursClaimed = totalTimeForDay(values)
  const overTime = hoursClaimed > hoursAvailable

  return (
    <fieldset>
      <div className="issCaseClaim--hoursAvailable">
        <HoursAvailable
          hoursAvailable={hoursAvailable}
          hoursClaimed={hoursClaimed}
          overTime={overTime}
        />
      </div>

      {values.map((educator, i) => (
        <Session
          key={i}
          onChange={onChange}
          values={educator}
          educators={educators}
          nameBase={nameBase + `[${i}]`}
          removeKey={removeKey}
          isEditing={curentlyEditingSession === i}
          changeEditingSession={() => changeEditingSession(i)}
          resetEditingSession={resetEditingSession}
          isOverTime={overTime}
        />
      ))}
      <FormButton
        center
        onClick={() => {
          changeEditingSession(values.length)
          addKey(nameBase, {
            hours: '1',
            minutes: '00',
            personnel_id: educators[0].id,
          })
        }}>
        <PlusIcon title="Add a educator" />
      </FormButton>
      <EnrolmentsInDay enrolments={enrolments} />
    </fieldset>
  )
}

export default SelectSessions



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-session/sessions.jsx